import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
    standalone: true
})
export class FilterPipe implements PipeTransform {
    transform<T>(data: T[], key: string, value: string): T[] {
        if (!value || !key || !data || data.length === 0) {
            return data;
        }

        if (!(key in (data[0] as object))) {
            console.log('error key does not exist on object');
            return data;
        }

        const q = value.toLowerCase();
        return data.filter(i => {
            const prop = (i as Record<string, unknown>)[key];
            return prop != null && String(prop).toLowerCase().includes(q);
        });
    }

}
